<template>
  <modalWindow v-if="changing" @close="clearMessage();changing=false" width="600">
    <div class="titlebar">Account koppelen</div>
    <div
      class="form-notice"
      v-if="$parent.$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
    >
      <strong>Indicatie (nieuwe of bestaande gebruiker)</strong><br />
      In het geval van een indicatie doel, kan er een indicatie e-mail (met offerte link) of
      een welkomst e-mail gestuurd worden.
      <br /><br />
      <strong>Nieuwe gebruiker</strong><br />
      Met het koppelen van een nieuwe gebruiker wordt er een welkomst
      e-mail (naar klant) en interne (leadbox) e-mail gestuurd.
      <br /><br />
      <strong>Nieuw doel bestaande gebruiker</strong><br />
      Bij een bestaande gebruiker (geverifieerd e-mail) wordt alleen
      een extra doel e-mail verzonden. Admin gebruikers krijgen geen e-mail.
      <br /><br />
      <strong>Herintake bestaande gebruiker</strong><br />
      Gebruikers krijgen geen e-mail.
    </div>
    <div v-if="msg.msg" :class="['form-' + msg.type]">{{ msg.msg }}</div>
    <form @submit.prevent class="inset">
      <select
        v-if="!$parent.$parent.redo && $parent.$parent.isOfferMail"
        ref="type" placeholder="Type e-mail"
      >
        <option value="offer" selected>Indicatie e-mail</option>
        <option value="welcome">Welkomst e-mail</option>
      </select>
      <input type=text ref="name" placeholder="Naam">
      <input type=email ref="email" placeholder="E-mail">
      <textarea ref="extra" placeholder="Extra e-mail inhoud"></textarea>
      <input type=submit @click="changeUser" value="Koppelen">
    </form>
  </modalWindow>
</template>

<script>
export default {
  name: 'ChangeUser',
  data() {
    return {
      changing: false,
      msg: { msg: null, type: 'notice' },
    };
  },
  methods: {
    clearMessage() {
      this.msg = { msg: null, type: 'notice' };
    },
    changeUser() {
      if (this.$refs.name.value && this.$refs.email.value) {
        this.changing = false;
        this.sdk.linkIntakeUser(
          this.getQueryVariable('intake'),
          this.$refs.email.value,
          this.$refs.name.value,
          (response) => {
            this.creating = false;
            if (response.status === 200) {
              window.onbeforeunload = () => {};
              window.location.reload();
            } else {
              this.msg = { msg: response.data.message, type: 'error' };
            }
          },
          this.$refs.extra.value,
          this.$refs.type ? this.$refs.type.value : '',
        );
      } else {
        this.msg = { msg: 'Vul alle velden in!', type: 'error' };
      }
    },
  },
};
</script>
